module.exports = __webpack_public_path__ + "static/media/weatherzone3.d4137aab.png";